import react,{useState} from "react";
import UserContext from "./UserContext";


const UserProvider = ({ children }) => {
  const [user, setUser] = useState(100); // your global state
  const [isProfileUpdated, setIsProfileUpdated] = useState(false);
  return (
    <UserContext.Provider value={{ user, setUser, isProfileUpdated, setIsProfileUpdated }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;